import React from 'react'
import { UpdatePopupStyle } from './style'
import { Box, Stack, Typography } from '@mui/material'
import ShowMoreText from "react-show-more-text";
import DeclineIcon from '../../../assets/declineIcon';
import ExpiredIcon from '../../amenitiesBooking/utils/expiredIcon';
import GreenTickConfirmed from '../../../assets/greenTickConfirmed';

export const RequestMessage = ({ type = "", title = "", message = "", remarks = "", subMessage = "" }) => {
    const classes = UpdatePopupStyle()
    return (
        <Box m={1} className={type === "Cancelled" ? classes.cancel_alert : type === "Rejected" ? classes.decline_alert : type === "Expired" ? classes.expired : classes.reconcile_alert} p={2}>

            <Stack direction={"row"} alignItems={"center"}>
                <Box>
                    {
                        type === "Cancelled" ?
                            // <CancelIcon sx={{fontSize:36, color:"#4E5A6B"}} />
                            <DeclineIcon />
                            :
                            type === "Rejected" ?
                                // <img src="../images/exicutedDeclined.svg" alt="decline" className={classes.decline_icon} />
                                <DeclineIcon />
                                :
                                type === "Expired" ?
                                    <ExpiredIcon />
                                    :
                                    <GreenTickConfirmed />
                    }
                </Box>

                <Stack sx={{ marginInlineStart: "16px" }}>
                    <Typography className={classes.alert_title}> {title} </Typography>
                    {/* <ShowMoreText
                        lines={1}
                        more="Show More"
                        less="Show Less"
                        className={classes.alert_content}
                        anchorClass={classes.alert_content}
                        expanded={false}
                        truncatedEndingComponent={"... "}
                    > */}
                    <Typography className={classes.alert_content} noWrap> {message} </Typography>
                    {subMessage && <Typography className={classes.alert_content} noWrap> {subMessage} </Typography>}
                    {/* </ShowMoreText> */}
                </Stack>
            </Stack>
            {
                remarks !== "" &&
                <ShowMoreText
                    lines={2}
                    more="Show More"
                    less="Show Less"
                    className={classes.remarks}
                    anchorClass={classes.remarks}
                    expanded={false}
                    truncatedEndingComponent={"... "}
                >
                    <Typography className={classes.remarks}> Remarks: {remarks} </Typography>
                </ShowMoreText>
            }
        </Box>
    )
}